import { TODAY } from "@/data/mock";

const nextDate = (base) => {
  const y = Number(TODAY.slice(0, 4));
  const md = base.slice(5);
  return `${`${y}-${md}` >= TODAY ? y : y + 1}-${md}`;
};
const daysBetween = (a, b) => Math.round((new Date(`${b}T12:00:00`) - new Date(`${a}T12:00:00`)) / 86400000);

export const upcomingBirthdays = (s, companyIds, within = 30) => {
  const items = [];
  s.companies.filter((c) => companyIds.includes(c.id)).forEach((c) => {
    if (c.foundedAt) items.push({ id: `co-${c.id}`, kind: "empresa", name: c.name, company: c.name, base: c.foundedAt });
    if (c.ownerBirthday) items.push({ id: `ow-${c.id}`, kind: "empresaria", name: c.owner, company: c.name, base: c.ownerBirthday });
  });
  s.collaborators
    .filter((c) => companyIds.includes(c.companyId) && c.birthday)
    .forEach((c) => items.push({ id: `cb-${c.id}`, kind: "colaboradora", name: c.name, company: s.companies.find((x) => x.id === c.companyId)?.name, base: c.birthday }));
  return items
    .map((i) => {
      const date = nextDate(i.base);
      return { ...i, date, days: daysBetween(TODAY, date), years: Number(date.slice(0, 4)) - Number(i.base.slice(0, 4)) };
    })
    .filter((i) => i.days <= within)
    .sort((a, b) => a.days - b.days);
};
